import Vue from 'vue';
import {effectivePrice,activeLevel} from '../../shared/pricing';
const clock = Vue.observable({now:Date.now(),offset:0,levels:[]});
let timer;
function tick(){clock.now=Date.now()+clock.offset;clearTimeout(timer);timer=setTimeout(tick,60000-clock.now%60000+25);}
tick();
document.addEventListener('visibilitychange',tick);
export function setPricing(data){clock.levels=data.priceLevels || [];const server=Date.parse(data.serverTime);clock.offset=Number.isFinite(server)?server-Date.now():0;tick();}
export function productPrice(product){return effectivePrice(product,clock.levels,new Date(clock.now));}
export function currentTariff(){const level=activeLevel(clock.levels,new Date(clock.now));return level ? level.name : '';}
